/* eslint-disable prettier/prettier */
import styled, {css, keyframes, withTheme} from 'styled-components';
import Spinner from '../../assets/images/downloading-spinner.svg';
import ListItemIcon from './ListItemIcon';

const animation = keyframes`
    0% {
        transform: scale(1) rotate(0deg);
    }
    100% {
        transform: scale(1) rotate(360deg);
    }
`;
const animationRule = css`
  ${animation} 2s infinite linear;
`;

const LoadingSpinnerIcon = styled(ListItemIcon)`
  background: none;
  position: relative;

  &:after {
    position: absolute;
    right: -5px;
    top: -8px;
    background-size: 80% !important;
    background: url(${Spinner}) no-repeat center center;
    animation: ${animationRule};
    content: '';
    width: 34px;
    height: 34px;
  }
`;

export default withTheme(LoadingSpinnerIcon);
